import { ItemType, type ItemsWithPagination } from '@inno-sdks/files'

/**
 * App ids were accidentally persisted as shortcut names by an older
 * provisioning flow. Keep these names explicit so cleanup cannot affect a
 * normal user-created shortcut with an unrelated name.
 */
const LEGACY_DEFAULT_SHORTCUT_NAMES: string[] = [
  'cluster-files',
  'cluster-cells',
  'cluster-slides',
  'cluster-pdf'
]

const legacyDefaultShortcutNames = new Set<string>(
  LEGACY_DEFAULT_SHORTCUT_NAMES
)

export const getLegacyDefaultShortcutIds = (
  rootFolderItems: ItemsWithPagination
): number[] =>
  rootFolderItems.data
    .filter(
      item =>
        item.type === ItemType.Shortcut &&
        legacyDefaultShortcutNames.has(item.name)
    )
    .map(item => item.id)
